<template>
  <div class="wrapper">
    <h1 class="dash-heading">{{ userProfile.districtName }} Dashboard</h1>
    <h3 v-if="dashboardView == 'units'" class="dash-heading">Please select from units available for your district:</h3>

    <div class="dash-banner">
      <!-- <h4>For an overview of how to use the Cereal City Science Online Component, please visit our <a href="https://youtu.be/uwLfnzisri0" target="_blank">YouTube Channel</a>. Timestamps with links have been provided to help navigate to specific topics of interest.</h4> -->

      <h4 class="announcement-banner">Due to the discontinuation of Google Jamboards in October 2024, teacher presentations and individual resources have been updated or replaced to reflect this change (see below). Please email info@bcamsc.org with any questions.</h4>
      

      <!-- <h4>New! Learn more about our <a href="https://cerealcityscience.org/professional-learning">FREE September Unit Trainings!</a></h4> -->
    </div>

    <div class="dash-components">
      <keep-alive>
        <units-list v-if="dashboardView == 'units'" />
      </keep-alive>
      <!-- ENG -->
      <unit-keng v-if="dashboardView == 'KENG'"/>
      <unit-1eng v-if="dashboardView == '1ENG'"/>
      <unit-2eng v-if="dashboardView == '2ENG'"/>
      <unit-3eng v-if="dashboardView == '3ENG'"/>
      <unit-4eng v-if="dashboardView == '4ENG'"/>
      <unit-5eng v-if="dashboardView == '5ENG'"/>
      <!-- LNG -->
      <unit-klng v-if="dashboardView == 'KLNG'"/>
      <unit-1lng v-if="dashboardView == '1LNG'"/>
      <unit-2lng v-if="dashboardView == '2LNG'"/>
      <unit-3lng v-if="dashboardView == '3LNG'"/>
      <unit-4lng v-if="dashboardView == '4LNG'"/>
      <unit-5lng v-if="dashboardView == '5LNG'"/>
      <!-- PNG -->
      <unit-kpng v-if="dashboardView == 'KPNG'"/>
      <unit-1png v-if="dashboardView == '1PNG'"/>
      <unit-2png v-if="dashboardView == '2PNG'"/>
      <unit-3png v-if="dashboardView == '3PNG'"/>
      <unit-4png v-if="dashboardView == '4PNG'"/>
      <unit-5png v-if="dashboardView == '5PNG'"/>

      <!-- Middle School -->
      <unit-mspng1 v-if="dashboardView == 'MSPNG1'"/>
      <unit-mspng2 v-if="dashboardView == 'MSPNG2'"/>
      <unit-mspng3 v-if="dashboardView == 'MSPNG3'"/>

      <unit-mseng1 v-if="dashboardView == 'MSENG1'"/>
      <unit-mseng2 v-if="dashboardView == 'MSENG2'"/>
      <unit-mseng3 v-if="dashboardView == 'MSENG3'"/>

      <unit-mslng1 v-if="dashboardView == 'MSLNG1'"/>
      <unit-mslng2 v-if="dashboardView == 'MSLNG2'"/>


    </div>



    <button type="button" name="button" v-if="dashboardView != 'units'" @click.prevent="cancelButton">Cancel</button>
  </div>
</template>

<script>
import UnitsList from './../../components/dashboard/UnitsList.vue'
// ENG
import UnitKeng from './../../components/units/UnitKENG.vue'
import Unit1eng from './../../components/units/Unit1ENG.vue'
import Unit2eng from './../../components/units/Unit2ENG.vue'
import Unit3eng from './../../components/units/Unit3ENG.vue'
import Unit4eng from './../../components/units/Unit4ENG.vue'
import Unit5eng from './../../components/units/Unit5ENG.vue'
// LNG
import UnitKlng from './../../components/units/UnitKLNG.vue'
import Unit1lng from './../../components/units/Unit1LNG.vue'
import Unit2lng from './../../components/units/Unit2LNG.vue'
import Unit3lng from './../../components/units/Unit3LNG.vue'
import Unit4lng from './../../components/units/Unit4LNG.vue'
import Unit5lng from './../../components/units/Unit5LNG.vue'
// PNG
import UnitKpng from './../../components/units/UnitKPNG.vue'
import Unit1png from './../../components/units/Unit1PNG.vue'
import Unit2png from './../../components/units/Unit2PNG.vue'
import Unit3png from './../../components/units/Unit3PNG.vue'
import Unit4png from './../../components/units/Unit4PNG.vue'
import Unit5png from './../../components/units/Unit5PNG.vue'
//MS
import UnitMspng1 from './../../components/units/UnitMSPNG1.vue'
import UnitMspng2 from './../../components/units/UnitMSPNG2.vue'
import UnitMspng3 from './../../components/units/UnitMSPNG3.vue'

import UnitMseng1 from './../../components/units/UnitMSENG1.vue'
import UnitMseng2 from './../../components/units/UnitMSENG2.vue'
import UnitMseng3 from './../../components/units/UnitMSENG3.vue'

import UnitMslng1 from './../../components/units/UnitMSLNG1.vue'
import UnitMslng2 from './../../components/units/UnitMSLNG2.vue'


import { mapState } from 'vuex'

export default {
  data() {
    return {

    }
  },
  components: {
    UnitsList,
    UnitKeng,
    Unit1eng,
    Unit2eng,
    Unit3eng,
    Unit4eng,
    Unit5eng,
    UnitKlng,
    Unit1lng,
    Unit2lng,
    Unit3lng,
    Unit4lng,
    Unit5lng,
    UnitKpng,
    Unit1png,
    Unit2png,
    Unit3png,
    Unit4png,
    Unit5png,
    UnitMseng1,
    UnitMseng2,
    UnitMseng3,
    UnitMspng1,
    UnitMspng2,
    UnitMspng3,
    UnitMslng1,
    UnitMslng2
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  }
}
</script>

<style lang="css" scoped>
h1 {
  margin-top: 20px;
  margin-bottom: 0;
}
h3 {
  margin-top: -15px;
}
.wrapper {
  display: grid;
  grid-template-rows: 1fr auto;
  grid-template-columns: auto;
  grid-gap: 20px;
}
/* .dash-heading {
  grid-column: 1 / 3;
} */
.dash-banner h4 {
  background: #f47e20;
  color: white;
  padding: 20px;
  margin-bottom: 10px;
  border: 1px solid #f47e20;
  border-radius: 5px;
}
.dash-banner a {
  color: white;
  text-decoration: underline;
}
.dash-banner .announcement-banner {
  background: #5e932f;
  color: white;
  padding: 20px;
  margin-bottom: 10px;
  border: 1px solid #5e932f;
  border-radius: 5px;
}
</style>
